// extracted by mini-css-extract-plugin
export default {"header":"gmcYlQ","title":"xr91hS","close-button":"IyBOX0","closeButton":"IyBOX0"};